
import { isIE } from '../utils/utils.browser-detection';

const 	scrollButton = document.querySelector('.js-form-scroll-link'),
		scrollToForm = document.querySelector('.js-scroll-to-form');

let		firstInput;


function formFocusAndHighlight() {
	firstInput.focus();
	scrollToForm.classList.add('highlight');
}

if ( scrollButton && scrollToForm ) {

	firstInput = scrollToForm.querySelector('input[type=text]');

	scrollButton.addEventListener( 'click', e => {
		e.preventDefault();
		
		if ( isIE() ) {

			document.documentElement.scrollTop = scrollToForm.offsetTop		
				
		} else {

			window.scrollTo({
				top: scrollToForm.offsetTop,
				left: 0,
				behavior: 'smooth'
			});

		}

		//setTimeout(formFocusAndHighlight, 1000);
	});	
}